import z from 'zod';

export const addEventStyleSchema = z.object({
  styleId: z.string().min(1, 'Style is required'),
});

export const addEventTextStyleSchema = z.object({
  textStyleId: z.string().min(1, 'Text style is required'),
});
